import {useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {PerfilUsuario} from '../../../../interfaces/perfil-usuario.interface'
import InputPhone from '../../../../components/Inputs/InputPhone'
import {DICCIONARIO} from '../../../../constants/Diccionario'

const MisDatos = () => {
  const profileData: PerfilUsuario = useSelector(
    (state: State) => state.gestionUsuario.perfilUsuario
  )

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec6-0b1e6fa6' className='w-layout-cell'>
      <div className='card w-form'>
        <form
          className='form-content'
          data-wf-page-id='64b58c72be2b65200b1e6fa6'
          data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'
        >
          <div>
            <h3 className='card-title l'>Mis Datos</h3>
          </div>
          <div className='form-separator'></div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='nombre' className='field-label m'>
                Nombre
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nombre'
                data-name=''
                placeholder='Nombre'
                id='nombre'
                disabled={true}
                value={`${profileData?.nombre} ${profileData?.apellido}`}
              />
            </div>
            <div className='label-input'>
              <label htmlFor='direccion' className='field-label m'>
                Correo electrónico
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='email'
                data-name='Correo electrónico'
                placeholder='Correo electrónico'
                id='email'
                disabled={true}
                value={profileData?.correo}
              />
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='nombre' className='field-label m'>
                Teléfono celular
              </label>
              <InputPhone
                className='m text-field w-input'
                name='telefono'
                value={profileData?.telefono ?? ''}
                disabled={true}
                onBlur={() => {}}
                onChange={() => {}}
              />
            </div>
            <div className='label-input'>
              <label htmlFor='direccion' className='field-label m'>
                Dirección
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='location'
                placeholder='Dirección'
                id='location'
                disabled={true}
                value={profileData?.direccion}
              />
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='email' className='field-label m'>
                Rol
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='rol'
                data-name='rol'
                placeholder='Rol de Usuario'
                id='rol'
                disabled={true}
                value={profileData?.rol === 2 ? 'Supervisor' : 'Facturador'}
              />
            </div>
            <div className='label-input'>
              <label htmlFor='nit' className='field-label m'>
                {`Tipo de identificación - ` + profileData.type_id_number}
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nit'
                data-name='nit'
                placeholder={profileData.type_id_number}
                id='nit'
                disabled={true}
                value={profileData?.id_number}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default MisDatos
